import axios from 'axios';
import { CONFIG } from "../config";


const API_BASE = `${CONFIG.API_URL}`;

axios.defaults.withCredentials = true;

function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      cookie = cookie.trim();
      if (cookie.startsWith(name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

api.interceptors.request.use(
  (config) => {
    const token = getCookie('csrftoken');
    if (token) {
      config.headers['X-CSRFToken'] = token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);


// ----------------------------------
// Sales & Deliveries
// ----------------------------------
export const getSalesOrders = () => api.get('/api/sales-orders/');
export const getShippedOrders = () => api.get('/api/shipped-orders/');
export const getSalesOrderInstance = (itemId) => api.get(`/api/sales/${itemId}/`);
export const updatePostInfo = (itemId, UpdatePayload) => api.patch(`/api/sales/${itemId}/postupdate/`, UpdatePayload);









